/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHiveIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-hive"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M16.77 11.32L19.93 11.32L21.1 9.35Q21.38 8.88 21.38 8.32Q21.38 7.78 21.1 7.3L20.5 6.3Q20.23 5.85 19.77 5.59Q19.32 5.33 18.8 5.33L16.77 5.33L14.97 8.32ZM10.43 15L13.57 15L15.38 12L13.57 9L10.43 9L8.63 12ZM10.43 7.67L13.57 7.67L15.38 4.67L14.15 2.65Q13.88 2.2 13.43 1.94Q12.97 1.68 12.45 1.68L11.55 1.68Q11.03 1.68 10.57 1.94Q10.13 2.2 9.85 2.65L8.63 4.67ZM9.03 8.32L7.22 5.33L5.2 5.33Q4.67 5.33 4.22 5.59Q3.77 5.85 3.5 6.3L2.9 7.3Q2.63 7.78 2.63 8.32Q2.63 8.88 2.9 9.35L4.08 11.32L7.22 11.32ZM9.03 15.68L7.22 12.68L4.08 12.68L2.9 14.65Q2.63 15.13 2.63 15.68Q2.63 16.23 2.9 16.7L3.5 17.7Q3.77 18.15 4.22 18.41Q4.67 18.68 5.2 18.68L7.22 18.68ZM10.43 16.32L8.63 19.32L9.85 21.35Q10.13 21.8 10.57 22.06Q11.03 22.32 11.55 22.32L12.45 22.32Q12.97 22.32 13.43 22.06Q13.88 21.8 14.15 21.35L15.38 19.32L13.57 16.32ZM16.77 18.68L18.8 18.68Q19.32 18.68 19.77 18.41Q20.23 18.15 20.5 17.7L21.1 16.7Q21.38 16.23 21.38 15.68Q21.38 15.13 21.1 14.65L19.93 12.68L16.77 12.68L14.97 15.68Z" fill={color} />
    </svg>
  );
}
